import React, { useContext } from 'react'

import { generateProductLinkingDataImage } from '@Components/Image'
import { ProductContext } from '@Components/Product/Context'

export const ProductLinkedData = () => {
  const product = useContext(ProductContext)

  if (!product) {
    return null
  }

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Product',
          name: product?.name,
          brand: product?.brand?.title,
          description: product?.description,
          url: product.url,
          // @ts-ignore
          image: generateProductLinkingDataImage(product?.primaryAsset?.url),
          offers: {
            '@type': 'Offer',
            availability: product?.availability?.isInStock ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
            // @ts-ignore
            price: product?.masterVariant?.linkingDataPrice?.discount?.format || product?.masterVariant?.linkingDataPrice?.format,
            // @ts-ignore
            priceCurrency: product?.masterVariant?.linkingDataPrice?.currencyCode,
          },

          ...product?.productReviews?.count && {
            aggregateRating: {
              '@type': 'AggregateRating',
              bestRating: 5,
              ratingValue: product?.productReviews?.averageRating,
              reviewCount: product?.productReviews?.count,
              worstRating: 1,
            },
          },
        }),
      }}
      id="product-ld"
      type="application/ld+json"
    />
  )
}
